import { reactive } from "vue";

export default reactive({
  authLoaded: false,
  currentUser: undefined,
  currentUserId: undefined,
  loginError: undefined,
});
